import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useListsStore } from '@shared/model'

import { useTutorKanbanStore } from './store'

interface MainInfoPaidLabelReturn {
  refValue: ComputedRef<string>
}

export const useMainInfoPaidLabel = (): MainInfoPaidLabelReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const listsStore = useListsStore()

  const refValue = computed<string>(() => {
    const paidLabelList = listsStore.getTutor?.paid_label ?? {}
    const paidLabel = tutorKanbanStore.getTutor?.paid_label

    return paidLabel ? paidLabelList[paidLabel] ?? '' : ''
  })

  return {
    refValue,
  }
}
